import React from "react";
import PropTypes from "prop-types";
import StyledFieldHelp from "./field-help.style";
export const FieldHelp = ({
  children,
  labelInline,
  labelWidth = 30,
  id
}) => /*#__PURE__*/React.createElement(StyledFieldHelp, {
  "data-element": "help",
  labelInline: labelInline,
  labelWidth: labelWidth,
  id: id
}, children);
export default FieldHelp;